<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Datum podání návrhu</label>
    <div class="input"><input type="text" pick-a-date [(ngModel)]="data.entryProposalDate" [maxToday]="true"/></div>
  </div>
</fieldset>
